export default __webpack_public_path__ + "static/media/residency visa religious purpose.c883c7fd.jpg";